import isMobile from 'is-mobile';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { rem, StyleProps, VStack } from '@bonusly/design-system';

import { GenericAttachment } from '../../../types/generic-attachment';
import { ImageOrVideo } from './image-or-video';

interface Props extends StyleProps {
	images: GenericAttachment[];
	variant?: string;
}

export const ImageList: FC<Props> = ({ images, ...rest }) => {
	const { t } = useTranslation('recognition');
	// We need to filter out the images that don't have a gif or mp4 a.k.a. the entry is a recorded video
	const filteredImages = images.filter((image) => image.gif || image.mp4);

	if (!filteredImages?.length) {
		return null;
	}

	return (
		<VStack {...rest} alignItems="flex-start" rowGap={3}>
			{images.map((image, index) => (
				<ImageOrVideo
					alt={image.alt_text || t('bonus_card.attachment')}
					borderRadius="md"
					key={index}
					maxH={rem(512)}
					src={isMobile() ? image.gif : image.mp4}
				/>
			))}
		</VStack>
	);
};
